module.exports = __webpack_public_path__ + "img/moustache-blue.ac44b1fe.svg";